var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as ServiceUtilisateur from '../services/utilisateur';
import { FormikGenerator } from '../utils/FormikGenerator';
import { Box, Paper, Stack } from '@mui/material';
import { classIconTitle } from '../utils/Classes';
import { Button } from '../utils/Button';
import { ConnexionIcon, HelpIcon, SendIcon } from '../utils/Icons';
import { useState } from 'react';
import { Typography } from '../utils/Typography';
import { Modal } from '../utils/Modal';
import { ResetMotPasse } from '../components/utilisateur/ResetMotPasse';
import { Snackbar } from '../utils/Snackbar';
import { Title } from './Title';
import { IconButton } from '../utils/IconButton';
var Login = function () {
    var queryParams = new URLSearchParams(window.location.search);
    var tokenRefreshPassword = queryParams.get('tokenRefreshPassword');
    var _a = useState(false), showMotPasseOublie = _a[0], setMotPasseOublie = _a[1];
    var onSubmit = function (_a) {
        var Societe = _a.Societe, Login = _a.Login, Password = _a.Password;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ServiceUtilisateur.login(Societe, Login, Password)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var onSendMail = function (_a) {
        var Societe = _a.Societe, Login = _a.Login, Email = _a.Email;
        return __awaiter(void 0, void 0, void 0, function () {
            var isSuccess;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ServiceUtilisateur.requestResetPassword(Societe, Login, Email)];
                    case 1:
                        isSuccess = _b.sent();
                        setMotPasseOublie(false);
                        if (isSuccess) {
                            Snackbar({ message: 'Email envoyé avec succès' });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var renderConnexion = function () {
        return (_jsx(_Fragment, { children: _jsx(FormikGenerator, { fields: [
                    [
                        {
                            autoFocus: true,
                            label: 'Société',
                            name: 'Societe',
                            isRequired: 'La société',
                        },
                        {
                            label: 'Login',
                            name: 'Login',
                            isRequired: 'Le login',
                        },
                        {
                            label: 'Mot de passe',
                            name: 'Password',
                            type: 'password',
                            isRequired: 'Le mot de passe',
                        },
                    ],
                ], renderSubmit: function (_a) {
                    var isSubmitting = _a.isSubmitting;
                    return (_jsxs(Stack, __assign({ className: "w-full mt-medium", spacing: 2, alignItems: "center" }, { children: [_jsx(Typography, __assign({ className: "pointer bold", variant: "body2", color: "primary", onClick: function () { return setMotPasseOublie(true); } }, { children: "Mot de passe oubli\u00E9 ?" })), _jsx(Button, __assign({ type: "submit", color: "primary", startIcon: _jsx(ConnexionIcon, {}), disabled: isSubmitting, loading: isSubmitting }, { children: "Connexion" }))] })));
                }, onSubmit: onSubmit }) }));
    };
    var renderContent = function () {
        return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ alignItems: "center" }, { children: [_jsx(Stack, __assign({ sx: classIconTitle() }, { children: _jsx("img", { src: "/icon.svg" }) })), _jsxs(Stack, __assign({ spacing: 2, alignItems: "center", sx: { marginTop: '30px' } }, { children: [_jsx(Title, {}), tokenRefreshPassword ? (_jsx(ResetMotPasse, { tokenRefreshPassword: tokenRefreshPassword })) : (renderConnexion())] }))] })), showMotPasseOublie && (_jsxs(Modal, __assign({ handleCloseModal: function () { return setMotPasseOublie(false); }, forceOpen: true, title: "Mot de passe oubli\u00E9" }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "neutre.main" }, { children: "Veuillez renseigner les informations ci-dessous." })), _jsx(Typography, __assign({ className: "mb-small", variant: "body2", color: "neutre.main" }, { children: "Un email vous sera envoy\u00E9 afin de vous permettre de saisir un nouveau mot de passe" })), _jsx(FormikGenerator, { fields: [
                                [
                                    {
                                        autoFocus: true,
                                        label: 'Société',
                                        name: 'Societe',
                                        isRequired: 'La société',
                                    },
                                    {
                                        label: 'Login',
                                        name: 'Login',
                                        isRequired: "Le login",
                                    },
                                    {
                                        label: 'Email',
                                        name: 'Email',
                                        isRequired: "L'email",
                                    },
                                ],
                            ], renderSubmit: function (_a) {
                                var isSubmitting = _a.isSubmitting;
                                return (_jsx(Stack, __assign({ className: "w-full mt-medium", alignItems: "center" }, { children: _jsx(Button, __assign({ type: "submit", color: "primary", startIcon: _jsx(SendIcon, {}), disabled: isSubmitting, loading: isSubmitting }, { children: "Envoyer mail" })) })));
                            }, onSubmit: onSendMail })] })))] }));
    };
    return (_jsx(_Fragment, { children: _jsxs(Stack, __assign({ alignItems: "center", justifyContent: "center", sx: {
                background: 'linear-gradient(180deg, #4b7084, 5%, #219C90, 50%, #6daf95)',
                height: 'initial',
                minHeight: '100%',
            } }, { children: [_jsx(IconButton, __assign({ tooltip: "Plus d'informations ?", color: "white", className: "absolute", sx: { top: 5, right: 5 }, onClick: function (e) {
                        e.preventDefault();
                        window.open(process.env.REACT_APP_URL_DEMO, '_blank');
                    } }, { children: _jsx(HelpIcon, { fontSize: "large" }) })), _jsx(Stack, __assign({ alignItems: "center", justifyContent: "center", className: "h-full w-full", component: "main" }, { children: _jsx(Box, __assign({ className: "mt-small mb-small p-small", sx: { maxWidth: 400 } }, { children: _jsx(Paper, __assign({ className: "p-large" }, { children: renderContent() })) })) }))] })) }));
};
export { Login };
//# sourceMappingURL=Login.js.map